import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";
import { ORGANIZATION_AUTHENTICATION } from "../types";
import {
  organizationAuthenticationPending,
  organizationAuthenticationFulfilled,
  organizationAuthenticationRejected,
} from "../actions/organizationAuthenticationActions";
import { sendApiRequest, notifyWarning, notifyError } from "../actions";
import generateError from "../utilities/generateError";
import { ORGANIZATION_MESSAGES } from "../constants/organizationMessages";
const createPayload = (payload) => ({
  method: "get",
  url: "auth/AttemptAuthentication",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(ORGANIZATION_MESSAGES.NOT_FOUND)
        : organizationAuthenticationFulfilled(response),
  ],
  onError: [
    organizationAuthenticationRejected,
    (error) =>{  
      return notifyError(generateError(error))},
  ],
  data: payload,
});
const meta = {
  api: "ajaxApiNoAuthorize",
};
const organizationAuthenticationEpic$ = (action$) =>
  action$.pipe(
    ofType(ORGANIZATION_AUTHENTICATION.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(organizationAuthenticationPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );
export default organizationAuthenticationEpic$;



// WEBPACK FOOTER //
// ./src/epics/organizationAuthenticationEpic.js